import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

export const procentaMinimum10Validation = () => [
    () => ({
        validator(_rule: RuleObject, value: string | number) {
            if ((!value && value + '' !== '0') || (Number(value) >= 10 && Number(value) <= 100))
                return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_PROCENTA_100</TranslateText>);
        }
    })
];

export default procentaMinimum10Validation;
